module.exports = __webpack_public_path__ + "img/icon-plus-purple.603433de.svg";